import { render, staticRenderFns } from "./ShowTaskDataModal.vue?vue&type=template&id=7d0ce831"
import script from "./ShowTaskDataModal.vue?vue&type=script&lang=js"
export * from "./ShowTaskDataModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports